<template>
	<div class="app-container userIndex">
		<el-card>
			<div slot="header" class="clearfix">
				<h3 class="pageName">{{pageName}}</h3>
			</div>
			<!-- 搜索表单 -->
			<el-form :model="queryParams" ref="queryForm" :inline="true" size="small" class="box_form">
				<el-form-item label="姓名:" prop="userName">
					<el-input v-model="queryParams.userName" placeholder="姓名" clearable
						@keyup.enter.native="handleQuery" @change="$forceUpdate()"></el-input>
				</el-form-item>
				<el-form-item label="手机号:" prop="mobile">
					<el-input v-model="queryParams.mobile" placeholder="手机" clearable @keyup.enter.native="handleQuery"
						@change="$forceUpdate()"></el-input>
				</el-form-item>
				<el-form-item label="用户状态:" prop="userStatus">
					<el-select filterable v-model="queryParams.userStatus" placeholder="状态" clearable
						@change="$forceUpdate()">
						<el-option v-for="(item, index) in userStatus" :key="index" :label="item.name"
							:value="item.value" />
					</el-select>
				</el-form-item>
				<el-form-item label="注册时间:" prop="time">
					<el-date-picker v-model="queryParams.time" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
						:default-time="['00:00:00', '23:59:59']" range-separator="-" start-placeholder="注册时间"
						end-placeholder="注册时间" @change="$forceUpdate()"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
					<el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
					<el-button icon="el-icon-download" @click="handleExport">导出数据</el-button>
				</el-form-item>
			</el-form>
			<!-- 数据列表 -->
			<el-table v-loading="loading" element-loading-text="加载中" :data="list">
				<el-table-column label="序号" align="center" type="index" width="50" />
				<el-table-column label="头像" align="center" prop="avatarUrl" width="150">
					<template slot-scope="scope">
						<el-image fit="contain" class="tableImg" :src="scope.row.avatarUrl"
						  :preview-src-list="[scope.row.avatarUrl]" >
						  <div slot="error" class="image-slot">
							<i class="el-icon-picture-outline"></i>
						  </div>
						</el-image>
					</template>
				</el-table-column>
				<el-table-column label="姓名" align="center" prop="userName" />
				<el-table-column label="手机号" align="center" prop="mobile" />
				<el-table-column label="OpenId" align="center" prop="openId" />
				<el-table-column label="举办赛事" align="center" prop="matchNum"></el-table-column>
				<el-table-column label="参与赛事" align="center" prop="applyNum"></el-table-column>
				<el-table-column label="所在省市" align="center" prop="provinceName">
					<template slot-scope="scope">
						<span> {{ scope.row.provinceName }} {{ scope.row.cityName }} </span>
					</template>
				</el-table-column>
				<el-table-column label="用户状态" align="center" prop="userStatus">
					<template slot-scope="scope">
						<span class="statusTag success" v-if="scope.row.userStatus == '1'"> 正常 </span>
						<span class="statusTag danger" v-if="scope.row.userStatus != '1'"> 禁用 </span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="200">
					<template slot-scope="scope">
						<el-button size="small" plain type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)">  编辑</el-button>
						<el-button size="small" plain type="success" icon="el-icon-arrow-down" @click="handleDtl(scope.row)">  详情</el-button>
					</template>
				</el-table-column>
			</el-table>

			<pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="_getList" />
				
			<!-- 新增、修改弹窗 -->
			<el-dialog :title="dialogName" :visible.sync="dialogShow" width="600px" append-to-body>
				<el-form ref="setform" :model="setParams" size="mini" :rules="rules" label-width="120px">
					<el-form-item label="姓名:" prop="userName">
						<el-input v-model="setParams.userName" placeholder="用户姓名" clearable style="width: 200px"
							@keyup.enter.native="handleQuery" @change="$forceUpdate()"></el-input>
					</el-form-item>
					<el-form-item label="所在省市:" prop="provinceCityInfo">
						<el-cascader v-model="setParams.provinceCityInfo" :options="province_list"
							style="width: 200px"
							@change="changeProvince" placeholder="选择省市"
							:props="{ label: 'name', value: 'code', checkStrictly: false, expandTrigger: 'hover' }"
							ref="tree"></el-cascader>
					</el-form-item>
					<el-form-item label="性别:" prop="sex">
						<el-radio-group v-model="setParams.sex">
							<el-radio :label="0">男</el-radio>
							<el-radio :label="1">女</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="生日:">
						<el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="请选择日期" style="width: 200px"
							v-model="setParams.birthday"></el-date-picker>
					</el-form-item>
					<el-form-item label="用户状态:" prop="userStatus">
						<el-radio-group v-model="setParams.userStatus">
							<el-radio label="1">启用</el-radio>
							<el-radio label="2">禁止登录</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogShow = false">取 消</el-button>
					<el-button type="primary" @click="submitForm">保存</el-button>
				</div>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
	import * as API_User from "@/api/sportManage/user";
	import * as API_Base from "@/api/sportManage/system/base"
	import Cookies from "js-cookie";

	export default {
		name: "userIndex",
		data() {
			return {
				pageName: '用户管理',
				userStatus: [{
						value: '1',
						name: "正常",
					},
					{
						value: '2',
						name: "禁用",
					},
				],
				queryParams: {
					keyWord: '',
					userStatus: '',
					pageNum: 1,
					pageSize: 10,
					time: [],
				},
				list: [],
				total: 0,
				loading: false,

				dialogShow: false,
				setParams: {
					status: '0',
					userStatus: '0',
					remark: '',
					sex: 0
				},
				rules: {
					userName: [{
						required: true,
						message: "请输入用户姓名",
						trigger: "change"
					}],
					provinceCityInfo: [{
						required: true,
						message: "请选择省市",
						trigger: "blur",
					}],
					sex: [{
						required: true,
						message: "请选择性别",
						trigger: "blur",
					}],
					userStatus: [{
						required: true,
						message: "请选择用户状态",
						trigger: "blur",
					}],
				},
				dialogName: '编辑用户',
				province_list: [],
			};
		},
		created() {
			this._getList();
			this.getProvince();
		},
		methods: {
			//查询-重置-刷新列表
			handleQuery() {
				this.queryParams.startTime = this.queryParams.time ? this.queryParams.time[0] : "";
				this.queryParams.endTime = this.queryParams.time ? this.queryParams.time[1] : "";
				this.queryParams.pageNum = 1;
				this._getList();
			},
			resetQuery() {
				this.$refs["queryForm"].resetFields();
				this.queryParams.startTime = ''
				this.queryParams.endTime = ''
				this._getList();
			},
			refreshList() {
				this.resetQuery();
				this.dialogShow = false
			},
			
			// 接口-数据导出
			handleExport() {
				this.download(
					"/biz/member/export", {
						...this.queryParams,
					},
					`用户列表` + new Date().getTime() + `.xlsx`
				);
			},
			// 接口-用户列表
			_getList() {
				API_User.userList(this.queryParams).then((res) => {
          console.log('用户列表')
          console.log(res)
					this.total = res.data.total;
					this.list = res.data.list;
				}).catch((err) => {

				});
			},
			// 接口-用户编辑
			_editUser() {
				API_User.editUser(this.setParams).then((res) => {
					console.log(res);
					this.$message({
						message: '编辑成功',
						type: 'success'
					})
					this.refreshList()
				}).catch((err) => {});
			},
			// 编辑用户
			handleEdit(row) {
				console.log(row);
				this.dialogShow = true
				this.dialogName = '编辑用户"'+row.userName + '"'
				this.setParams = JSON.parse(JSON.stringify(row));
				// birthday
				console.log(this.setParams);
				let arr = []
				arr.push(this.setParams.provinceNo)
				arr.push(this.setParams.cityNo)
				this.setParams.provinceCityInfo = arr
			},
			//跳转-用户详情
			handleDtl(row) {
				console.log(row);
				this.$router.push({
					path: '/sportManage/userDetail',
					query: {
						id: row.id,
					},
				})
			},
			//操作-提交表单
			submitForm() {
				this.$refs['setform'].validate((valid) => {
					if (valid) {
						this._editUser()
					} else {
						console.log('error submit!!');
						this.$message({
							message: '填写数据不全或数据有误',
							type: 'error'
						});
						return false;
					}
				});
			},
			//省市区三级联动
			changeProvince(e) {
				if (this.$refs.tree.getCheckedNodes()[0]) {
					let data = this.$refs.tree.getCheckedNodes()[0].pathLabels.toString()
					let dataArr = data.split(',')
					if (dataArr.length == 2) {
						this.setParams.cityName = dataArr[1]
					} else {
						this.setParams.cityName = dataArr[0]
					}
					if (e) {
						this.setParams.provinceNo = e[0]
						this.setParams.cityNo = e[1]
					}
					console.log(e)
				}
			},
			// 接口-获取省市
			getProvince() {
				API_Base.provincePclist().then((res) => {
					this.province_list = res.data
				})
			},
		},
	};
</script>

<style lang="scss">
	@import "../../../assets/styles/common.scss";

	.userIndex {
		padding: 40px 40px;
		color: #676a6c;
		font-size: 13px;
		font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
		overflow-x: hidden;

	}
</style>